import { createVanIconComponent } from "./van"

const Medal = createVanIconComponent("medal")
export default Medal
